export function createUndoId(prefix = "undo") {
	return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
